import { prodOrDevCdnParam } from './isEnv'

const thumbnail = (size, img, fallback) => {
  if (img && img.url) {
    return img.url
  } else if (img && img.path && img.ext) {
    return `${img.path}_${size}${img.ext}`
  } else if (fallback && fallback.defaultAvatar && size) {
    return `${process.env.REACT_APP_BUNNY_CDN_IMAGE_ROOT}/dev/application/avatars/${fallback.color || 'blue'}/${size}/${fallback.defaultAvatar}.webp`
  } else {
    return ''
  }
}

// NOTE: duplicating above logic to not slow down above function further
const isAvatarSrc = (size, img, defaultAvatar) => {
  if (img && img.url) {
    return false
  } else if (img && img.path && img.ext) {
    return false
  } else if (defaultAvatar && size) {
    return true
  } else {
    return false
  }
}

const socialBackgroundWithFallback = (user) => 
  user?.socialMedia?.profile_background?.url ||
  `https://mandrake-app.b-cdn.net/${prodOrDevCdnParam()}/application/display_elements/default-social-background.jpg`

const thumbnailSmallBlue = (img, defaultAvatar) => thumbnail(
  'small', img, { defaultAvatar }
)

const thumbnailMediumBlue = (img, defaultAvatar) => thumbnail(
  'medium', img, { defaultAvatar }
)

const thumbnailMediumNoFallback = (img) => thumbnail(
  'medium', img,
)

const thumbnailLargeNoFallback = (img) => thumbnail(
  'large', img,
)

export {
  thumbnail,
  isAvatarSrc,

  thumbnailSmallBlue,
  thumbnailMediumBlue,

  thumbnailMediumNoFallback,
  thumbnailLargeNoFallback,

  socialBackgroundWithFallback,
}